export default function Footer() {
  return (
    <footer className="app-footer">
      <span><span className="footer-brand">Fwalt</span><span className="footer-brand-blue">News</span> — Real-time news aggregator</span>
      <span>&copy; 2026 Foko Walter. All Rights Reserved</span>
      <span>Powered by AI</span>
    </footer>
  );
}
